var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaddle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 731 731",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 35 431 C 27 411 33 405 55 397 68 393 83 387 94 379 110 368 109 351 92 340 81 333 67 328 54 323 33 317 29 311 35 290 43 260 58 233 80 210 122 165 174 159 229 191 278 220 326 249 376 275 420 298 469 308 520 312 568 316 616 320 664 324 688 326 704 341 704 361 704 380 689 394 665 396 629 400 593 403 557 405 462 409 381 436 303 487 279 502 251 517 226 532 150 573 91 534 66 493 53 474 43 453 35 431 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaddle);
export default __webpack_public_path__ + "static/media/saddle.b187a2023e6b6bb73c1580f1ded17353.svg";
export { ForwardRef as ReactComponent };